import { jsxs as e, jsx as o } from "react/jsx-runtime";
const C = ({ className: r }) => /* @__PURE__ */ e(
  "svg",
  {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M16.25 5.36121L15.7336 13.7155C15.6016 15.8499 15.5356 16.9171 15.0006 17.6844C14.7361 18.0638 14.3955 18.3839 14.0006 18.6246C13.2018 19.1112 12.1325 19.1112 9.99395 19.1112C7.8526 19.1112 6.78192 19.1112 5.98254 18.6236C5.58733 18.3826 5.24666 18.0619 4.98224 17.6819C4.4474 16.9134 4.38288 15.8446 4.25384 13.7072L3.75 5.36121",
          stroke: "currentColor",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M2.5 5.36113H17.5M13.3798 5.36113L12.8109 4.18756C12.433 3.40801 12.244 3.01823 11.9181 2.77513C11.8458 2.72121 11.7692 2.67324 11.6892 2.63171C11.3283 2.44446 10.8951 2.44446 10.0288 2.44446C9.14069 2.44446 8.69665 2.44446 8.32974 2.63956C8.24842 2.6828 8.17082 2.7327 8.09774 2.78876C7.76803 3.04171 7.58386 3.44575 7.2155 4.25384L6.71077 5.36113",
          stroke: "currentColor",
          strokeLinecap: "round"
        }
      )
    ]
  }
);
export {
  C as DeleteIcon
};
